<template>
	<nk-dropdown v-model="dropdownValue" :data="dropdownData" :disabled="disabled ? true : null" :options="settings.dropdownOptions" ref="input" :tabindex="tabindex"></nk-dropdown>
</template>
<script>
	import _ from 'lodash'
	import { mapActions, mapGetters } from 'vuex'
	import $sc from '~/plugins/shortcut.collection.js'
	import productPriceGroup from '~/views/sale/products/product-price-group-list.vue'

	export default {
		props: {
			modelValue: {},
			options: {},
			disabled: { type: Boolean, default: false },
			tabindex: {}
		},
		emits: ['update:modelValue'],
		data() {
			return {
				settings: {
					type: null,
					dropdownOptions: {
						rowIdentifier: 'id',
						remoteSearch: false,
						placeholder: this.$t('select-it'),
						searchableFields: ['name'],
						findExactMatch: this.findExactMatch,
						selectorWidth: 'auto',
						buttons: [{
							title: this.$t('manage-items'),
							shortcut: $sc.find('enter'),
							element: () => { return this.$el },
							isPrimary: true,
							icon: 'list-ul',
							handle: (button, page, e) => {
								this.showProductPriceGroups()
							}
						}]
					}
				},
				localValue: null
			}
		},
		computed: {
			...mapGetters({
				all: 'productPriceGroups/all'
			}),
			dropdownValue: {
				get() {
					return this.localValue
				},
				set(val) {
					this.$emit('update:modelValue', val)
					this.localValue = val
				}
			},
			dropdownData() {
				return this.all
			}
		},
		watch: {
			modelValue: {
				handler(val, oldVal) {
					this.localValue = val
				}
			},
			options: {
				immediate: true,
				deep: true,
				handler(val) {
					this.settings = _.extend({}, this.settings, val)
				}
			}
		},
		created() {
			this.localValue = this.modelValue
		},
		mounted() {
			this.refreshProductPriceGroups()
		},
		methods: {
			...mapActions({
				refreshProductPriceGroups: 'productPriceGroups/refresh'
			}),
			showProductPriceGroups() {
				this.showModal({ component: productPriceGroup, data: null, options: { type: this.settings.type, selectable: true } })
					.then(result => {
						this.dropdownValue = result
						this.$refs.input.focusAndSelect()
					}).catch(() => { })
			}
		},
	}
</script>
<style></style>
